// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tree-node.is-current>.el-tree-node__content[data-v-2a38b32e]{background-color:#000!important;color:#fff}.el-checkbox__input.is-checked+.el-checkbox__label[data-v-2a38b32e]{color:#000}", ""]);
// Exports
module.exports = exports;
